module.exports = __webpack_public_path__ + "img/pancake.bcc5271f.png";